import {initializeApp} from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/storage';

const config = {
    develop: {
        apiKey: 'AIzaSyCBPSJyCgzRdnwQLzCunHjq8-82tMwI3Cs',
        authDomain: 'herbzy-space-contact-form.firebaseapp.com',
        databaseURL: 'https://herbzy-space-contact-form.firebaseio.com',
        projectId: 'herbzy-space-contact-form',
        storageBucket: 'herbzy-space-contact-form.appspot.com',
        messagingSenderId: '824476194055',
        appId: '1:824476194055:web:bfb647247c9dcce19be1a2',
        measurementId: 'G-1917L67K9W',
    },
};

const firebase = initializeApp(config['develop']);
export default firebase;
